import React, { useEffect, useRef, useState } from 'react'
import Modal from '../../../../Modal/Modal';

import SelectInput from './SelectInput';
import { useDispatch, useSelector } from 'react-redux';
import SelectOutputs from './SelectOutputs';
import SelectRule from './SelectRule';
import SelectType from './SelectType';
import ChoosePin from './../CreateRuleNew/ChoosePin'
import { createAdvRuleApi, setInputRuleApi } from '../../../../../Api Methods/Api';
import ChooseWhen from '../CreateRuleNew/ChooseWhen';
import ChooseAffectedPin from '../CreateRuleNew/ChooseAffectedPin';
import ChooseWhat from '../CreateRuleNew/ChooseWhat';
import ChooseTime from '../CreateRuleNew/ChooseTime';
import { RuleProvider, useRule } from '../CreateRuleNew/RuleReducer';
import ChooseWhatAdvRule from '../CreateRuleNew/ChooseWhatAdvRule';
import { Dialog } from 'primereact/dialog';
import Lottie from 'lottie-react';
import { Button } from 'primereact/button';
import successAnim from '../../../../../assets/animations/success.json'
import failAnim from '../../../../../assets/animations/fail.json'
import ChooseLocation from '../CreateRuleNew/ChooseLocation';
import ChooseAffectedGeofencePin from '../CreateRuleNew/ChooseAffectedGeofencePin';
import ChooseWhatGeofence from '../CreateRuleNew/ChooseWhatGeofence';
import ChooseAdditionalConditionPin from '../CreateRuleNew/ChooseAdditionalConditionPin';

const CreateRule = ({ allListOptionsArray, OutPutsPinNames, setShowAutomation, fetchAutomations, firmware, smartLocks, setSuccessVisible, setFailVisible, siteType, advanced }) => {
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    
    const apiDispatch = useDispatch();
    const apiData = {
        token,
        client
    }

    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);

    const [direction, setDirection] = useState("")
    const [geograph, setGeograph] = useState({})
    //------------------------------- Modal Logic  ----------------------------------------------

    const ModalDialog = useRef();

    // call ref to clearStates method from child component ScheduledAction.
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        //reset states for scheduled Action
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            // Call the child method
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        }

        HandelResetModal();
    }
    //-------------------------------------------------------------------------------------------------

    // reset model when Escape key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Handle the Escape key press here
                HandelResetModal();
                setModalPageIndex(null);
            }
        };

        // Add event listener when component mounts
        document.addEventListener('keydown', handleKeyDown);


        // Clean up event listener when component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);


    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowAutomation(null);
    }


    const [body, setBody] = useState({
        uuid: DeviceUUID,
        input: 'null',
        inputType: "null",
        inputRule: "null",
        outputs: "null",
        active: 1 ? "1" : "0"
    })
    const [inputTypeText, setinputTypeText] = useState(null)

    useEffect(() => {
        switch (modalPageIndex) {
            case 0:
                // setModalComponent(<SelectInput body={body} setBody={setBody} listItems={allListOptionsArray} outputList={OutPutsPinNames} nextPage={setModalPageIndex} />)
                setModalComponent(<ChoosePin pins={allListOptionsArray} firmware={firmware} smartLocks={smartLocks} navigate={setModalPageIndex} siteType={siteType} advanced={advanced} setDirection={setDirection} />)
                HandleShowModal();
                break;
            case 1:
                setModalComponent(<ChooseWhen navigate={setModalPageIndex} />)
                break;
            case 2:
                setModalComponent(<ChooseAffectedPin navigate={setModalPageIndex} pins={allListOptionsArray} smartLocks={smartLocks} createRule={CreateRule}/>)
                break;
            case 3:
                setModalComponent(<ChooseWhat navigate={setModalPageIndex} createRule={CreateRule}/>)
                break;
            case 4:
                setModalComponent(<ChooseTime navigate={setModalPageIndex} createRule={CreateRule}/>)
                break;
            case 5: 
                setModalComponent(<ChooseWhatAdvRule navigate={setModalPageIndex} createRule={CreateRule}/>)
                break;
            case 6: 
                setModalComponent(<ChooseLocation navigate={setModalPageIndex} createRule={CreateRule} direction={direction} setGeograph={setGeograph}/>)
                break;
              case 7:
                setModalComponent(<ChooseAffectedGeofencePin navigate={setModalPageIndex} pins={allListOptionsArray} smartLocks={smartLocks} createRule={CreateRule} direction={direction}/>)
                break;
            case 8:
                setModalComponent(<ChooseWhatGeofence navigate={setModalPageIndex} createRule={CreateRule}/>)
                break;
            case 9:
                setModalComponent(<ChooseAdditionalConditionPin navigate={setModalPageIndex} pins={allListOptionsArray} smartLocks={smartLocks} />)
                break;
            case 10:
                setModalComponent(<ChooseWhen navigate={setModalPageIndex} backStep={9} />)
                break;
        }
    }, [modalPageIndex]); // Empty dependency array ensures it runs only once after initial render


    const CreateRule = async (inputRule, pinsToAffect, state) => {
        if (state.isAdvRule || state.supportsAdvRules){            
            const advRuleBody = {
                site_owner: String(state.deviceUUID),
                name: String(state.name),
                description: String(state.description),
                conditions_logic_operator: String(state.conditions_logic_operator),
                is_enabled: true,
                conditions: state.conditions,
                actions: state.actions,
                ...(state.timeframe_window_ms ? { timeframe_window_ms: state.timeframe_window_ms } : {})
            }
            const response = await createAdvRuleApi(apiData, advRuleBody, apiDispatch)
            if (response.success) {
                
                HandleCloseModal();
                setSuccessVisible(true)
                
            } else {
                setFailVisible(false);
            }

        } else if (state.isGeofence) {
            const advRuleBody = {
                site_owner: String(state.deviceUUID),
                name: `${String(state.geofenceDirection)} geofence rule`,
                description: String(state.description),
                conditions_logic_operator: String(state.conditions_logic_operator),
                is_enabled: true,
                conditions: state.conditions, //this wont work, needs a default condition
                actions: state.actions
            }
            const response = await createAdvRuleApi(apiData, advRuleBody, apiDispatch)
            if (response.success) {
                HandleCloseModal();
                setSuccessVisible(true)
            } else {
                setFailVisible(false);
            }
        } else {
            const outputsArray = pinsToAffect.map(pin => pin.Pin)
            let outputsAffectedString;
            if (!state.isInput){
                outputsAffectedString = `${state.pinNumber},${outputsArray.join(",")}`
            } else {
                outputsAffectedString = outputsArray.join(",")
            }

            let deviceUUID = state.deviceUUID
            if (deviceUUID == "" || deviceUUID == undefined){
                deviceUUID = pinsToAffect.find(pin => pin.DeviceUUID).DeviceUUID
            }

            const ruleBody = {
                uuid: deviceUUID,
                input: String(state.pinNumber), 
                outputs: outputsAffectedString,
                inputRule: String(inputRule),
                inputType: String(state.inputType),
                active: "1"
            }

            const response = await setInputRuleApi(apiData, ruleBody, apiDispatch)
            if (response.rule == 'sent') {
                HandleCloseModal();
                fetchAutomations();
                setSuccessVisible(true);
            } else {
                setFailVisible(true)
            }
        }
    }

    return (
        <>
            <Modal ref={ModalDialog} title={"Create rule"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "700px", minHeight: "420.5px" }} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

            

        </>
    )
}

export default CreateRule